import gql from 'graphql-tag';

export const UPSERT_USER = gql`
  mutation UpsertUser($input: UserUpsertInput) {
    upsertUser(input: $input) {
      userId
      error
    }
  }
`;
